import { makeStyles } from '@material-ui/styles';
import React from 'react';
import SearchAndAddPatientsHeader from './index';
import useCheckMobileScreen from '../../hooks/useWidth';
const styles = makeStyles((theme) => ({
    column: {
        [theme.breakpoints.up(1025)]: {
            display: 'flex',
            flexDirection: 'column',
            // width: '100%',
            height: '100%'
        }
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row-reverse',
        marginBottom: '24px'
    }
}));
function WithHeader(WrappedComponent, Component) {
    return function PageContainer(props) {
        const isMobile = useCheckMobileScreen();
        const classes = styles();
        return (
            <>
                <div className={classes.column}>
                    {!isMobile && (
                        <div className={classes.row}>
                            <SearchAndAddPatientsHeader />
                            <Component />
                        </div>
                    )}
                    <WrappedComponent {...props} />
                </div>
            </>
        );
    };
}

export default WithHeader;
